//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import configuracaoCalendarioAprovacaoResource from '../../common/resources/configuracao/configuracao-calendario-aprovacao';

export default {
  name: 'ConfiguracaoCalendarioAprovacao',
  data() {
    return {
      confCalendarioAprovacaoResources: configuracaoCalendarioAprovacaoResource(this.$resource),
      aprovacoes: [],
      disableCheck: false,
    };
  },
  components: {},
  methods: {
    requestPopular() {
      this.confCalendarioAprovacaoResources.pesquisar()
        .then((response) => {
          const objeto = response.data;
          if (!objeto || !objeto.length) {
            return;
          }

          this.aprovacoes = objeto.map((el) => {
            el.valorParametro = el.valorParametro === 'true';
            return el;
          });
        });
    },
    requestAtualizar(objeto) {
      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(() => {
          const payload = Object.assign({}, objeto);
          delete payload.tabela;
          this.confCalendarioAprovacaoResources.atualizar(payload)
            .then(() => {
              this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
              this.atualizar(objeto);
              this.disableCheck = false;
            })
            .catch((err) => {
              this.$error(this, err);
              this.disableCheck = false;
            });
        }, 500);
      }
    },
  },
  mounted() {
    this.requestPopular();
  },
};



// WEBPACK FOOTER //
// ./src/spa/configuracao/ConfiguracaoCalendarioAprovacao.vue?vue&type=script&lang=js&